import React from "react";

import ManageOrganizationsView from "./ManageOrganizationsView";

const ManageOrganizations = () => {
  return <ManageOrganizationsView />;
};

export default ManageOrganizations;
